import React from 'react';
import {
  Document,
  DocumentAudio,
  DocumentBlank,
  DocumentPdf,
  DocumentVideo,
  Image,
  TableSplit,
} from '@carbon/icons-react';
import {
  CsvFile,
  DocFile,
  JpgFile,
  Mp3File,
  Mp4File,
  PngFile,
  PptFile,
  PresentationFile,
  SvgFile,
  WmvFile,
  XlsFile,
} from '@ditioas/web-ui';

import cn from 'libs/cn';

export const getFileExtensionFromName = (fileName: string) =>
  fileName.split('.').pop();

interface FileIconProps {
  fileExtension: string;
  className?: string;
  size?: number;
}

const FileIcon = ({ fileExtension, size, className }: FileIconProps) => {
  const iconProps = { size, className: cn('shrink-0', className) };

  switch (fileExtension) {
    case 'doc':
    case 'docx':
      return <DocFile {...iconProps} />;
    case 'pdf':
      return <DocumentPdf {...iconProps} />;
    case 'png':
      return <PngFile {...iconProps} />;
    case 'jpg':
      return <JpgFile {...iconProps} />;
    case 'jpeg':
      return <Image {...iconProps} />;
    case 'svg':
      return <SvgFile {...iconProps} />;
    case 'rtf':
    case 'pages':
      return <Document {...iconProps} />;
    case 'xls':
    case 'xlsx':
      return <XlsFile {...iconProps} />;
    case 'csv':
      return <CsvFile {...iconProps} />;
    case 'ppt':
    case 'pptx':
      return <PptFile {...iconProps} />;
    case 'key':
      return <PresentationFile {...iconProps} />;
    case 'numbers':
      return <TableSplit {...iconProps} />;
    case 'mp3':
      return <Mp3File {...iconProps} />;
    case 'wmv':
      return <WmvFile {...iconProps} />;
    case 'wav':
    case 'ogg':
    case 'flac':
      return <DocumentAudio {...iconProps} />;
    case 'mp4':
      return <Mp4File {...iconProps} />;
    case 'avi':
    case 'mpeg':
    case 'mov':
    case 'mkv':
    case 'm4v':
      return <DocumentVideo {...iconProps} />;

    default:
      return <DocumentBlank {...iconProps} />;
  }
};

export default FileIcon;
